/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyergenerating1Inputs */

const en_flyergenerating1 = /** @type {(inputs: Flyergenerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Composing…`)
};

const de_flyergenerating1 = /** @type {(inputs: Flyergenerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gestaltet…`)
};

/**
* | output |
* | --- |
* | "Composing…" |
*
* @param {Flyergenerating1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyergenerating1 = /** @type {((inputs?: Flyergenerating1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyergenerating1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyergenerating1(inputs)
	return de_flyergenerating1(inputs)
});
export { flyergenerating1 as "flyerGenerating" }